import { useCallback } from 'react'
import { usePostApiV1AccountsPasswordRecoverCheckCodeMutation } from '../../../../../authApi'
import { getServerApiErrorCode, ErrorT } from '@wellesley/error-kit'
import { useDispatch, useSelector } from 'react-redux'
import { authSlice } from '../../../../../authSlice'

export const fixedCacheKey =
  'usePostApiV1AccountsPasswordRecoverCheckCodeMutation'

export const useSendPassCode = () => {
  const dispatch = useDispatch()
  const { setForgotPasswordStep, resetForgotPasswordFields } = authSlice.actions
  const fields = useSelector(authSlice.selectors.selectForgotPasswordFields)

  const [sendCode, { isError, error, isLoading }] =
    usePostApiV1AccountsPasswordRecoverCheckCodeMutation({
      fixedCacheKey,
    })

  const send = useCallback(async (code: number) => {
    try {
      if (!fields?.login) throw new Error('No login fields from previous step')

      await sendCode({
        passwordRecoveryCode: { login: fields.login, code },
      }).unwrap()
      dispatch(setForgotPasswordStep('confirm'))
    } catch (error) {
      if (
        getServerApiErrorCode(error as ErrorT) === 'VerificationCodeTooMany'
      ) {
        dispatch(resetForgotPasswordFields())
        dispatch(setForgotPasswordStep('request'))
      }
    }
  }, [])

  return { send, isError, error, isLoading }
}
